module.exports = __webpack_public_path__ + "static/img/section-1-text.46ad2f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-1-text.png
// module id = ILzc
// module chunks = 1